export const TASKS_WITHOUT_MILESTONES_ROW = 'TASKS_WITHOUT_MILESTONES_ROW';

export const MIN_GANTT_HEIGHT = 300;

export const defaultHeaderHeight = 62;
export const defaultColumnWidth = 215;
export const defaultQuarterYearColumnWidth = 400;
export const defaultRowHeight = 44;
export const defaultBarFill = 60;
export const defaultBarCornerRadius = 3;
export const defaultHandleWidth = 8;
export const defaultArrowIndent = 20;
